import { render, staticRenderFns } from "./PeopleTile.vue?vue&type=template&id=362c4303&scoped=true&"
import script from "./PeopleTile.vue?vue&type=script&lang=js&"
export * from "./PeopleTile.vue?vue&type=script&lang=js&"
import style0 from "./PeopleTile.vue?vue&type=style&index=0&id=362c4303&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362c4303",
  null
  
)

export default component.exports